import React from 'react';
import "./contact-form.css";

export default function ContactForm() {
  return (
    <div className="ae-contact-form-container">
      <form
        name="contact"
        className="ae-contact-form"
        method="POST"
        data-netlify="true"
        action="/thank-you-for-contacting-us/"
        >
        <input 
          type="hidden" 
          name="form-name" 
          value="contact" 
        />
        <input
          placeholder="Full Name"
          className="ae-input-field"
          name="name"
          required
        />
        <input
          placeholder="Email address"
          className="ae-input-field"
          name="email"
          required
        />
        <input
          placeholder="Phone number"
          className="ae-input-field"
          name="phone"
          required
        />
        <textarea
          placeholder="Your message here..."
          className="ae-text-area"
          name="message" />
        <input
          type="submit"
          className="ae-button -contact-page -cta-dark"
          value="Get in touch"
        />
      </form>
    </div>
  )
}